import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserPasswordChangeModel } from './model/user-password-change.model';
import { UserModel } from './model/user.model';
import { environment } from '../../../../environments/environment';
import { UserSessionModel } from '../login/model/user-session.model';
import { UserPasswordChangeOtpModel } from './model/user-password-change-otp.model';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    BASE = environment.USER;
    IAM = environment.IAM;

    constructor(
        protected httpService: HttpClient
    ) { }

    public getUserInformation(userId: string): Observable<UserModel> {
        return this.httpService.get<UserModel>(`${this.BASE}/user/${userId}`);
    }
    public getUserSessions(): Observable<Array<UserSessionModel>> {
        return this.httpService.get<Array<UserSessionModel>>(`${this.IAM}/session/user`);
    }
    public passwordChange(passwordChange: UserPasswordChangeModel): Observable<void> {
        return this.httpService.patch<void>(`${this.BASE}/user/password/change`, passwordChange);
    }
    public passwordChangeByOtp(passwordChange: UserPasswordChangeOtpModel): Observable<void> {
        return this.httpService.patch<void>(`${this.BASE}/user/password/change/otp`, passwordChange);
    }
    public updateUser(userId: string, user: Partial<UserModel>): Observable<UserModel> {
        return this.httpService.patch<UserModel>(`${this.BASE}/user/${userId}`, user);
    }
}
